module.exports = __webpack_public_path__ + "static/media/balka2.48979840.png";